import { render } from "./TrgtRegister.vue?vue&type=template&id=f1c4b8da"
import script from "./TrgtRegister.vue?vue&type=script&lang=js"
export * from "./TrgtRegister.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__